import { useState } from "react";
import { reportService } from "../services/auditService";

const isAuthError = (err) => {
  const status = err?.response?.status;
  return status === 401 || status === 403;
};

export const useReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sellReport, setSellReport] = useState(null);
  const [purchaseReport, setPurchaseReport] = useState(null);
  const [summaryReport, setSummaryReport] = useState(null);

  const generateSellReport = async (startDate, endDate) => {
    setLoading(true); setError(null);
    try {
      const data = await reportService.generateSellReport(startDate, endDate);
      setSellReport(data); return data;
    } catch (err) {
      if (!isAuthError(err)) { setError(err.message); throw err; }
    } finally { setLoading(false); }
  };

  const generatePurchaseReport = async (startDate, endDate) => {
    setLoading(true); setError(null);
    try {
      const data = await reportService.generatePurchaseReport(startDate, endDate);
      setPurchaseReport(data); return data;
    } catch (err) {
      if (!isAuthError(err)) { setError(err.message); throw err; }
    } finally { setLoading(false); }
  };

  const generateSummaryReport = async (startDate, endDate) => {
    setLoading(true); setError(null);
    try {
      const data = await reportService.generateSummaryReport(startDate, endDate);
      setSummaryReport(data); return data;
    } catch (err) {
      if (!isAuthError(err)) { setError(err.message); throw err; }
    } finally { setLoading(false); }
  };

  return { loading, error, sellReport, purchaseReport, summaryReport, generateSellReport, generatePurchaseReport, generateSummaryReport };
};
